import React, { useEffect, useState } from 'react';
import { Layout, Spin, Radio } from 'antd';
import { useLocation } from 'react-router-dom';
import mermaid from 'mermaid';
import type { RadioChangeEvent } from 'antd';
import { useStore } from '../../../../store';
import { useActions } from '../../../providers/actions-provider/actions.context';
import PageTitle from '../../../lib/page-title';

const Erd = (): JSX.Element => {
  const { pathname } = useLocation();
  const property = pathname.split('/').splice(-2, 2).pop() || '';
  const { tenantActions } = useActions();
  const [level, setLevel] = useState('1');
  mermaid.initialize({
    startOnLoad: true,
    theme: 'default',
    securityLevel: 'loose',
    fontFamily: 'Fira Code',
    er: {
      fontSize: 24,
    },
  });
  const {
    mermaidDiagram,
  } = useStore();
  const {
    data, loaded, loading, error,
  } = mermaidDiagram;
  const options = [
    { label: 'Level 1', value: '1' },
    { label: 'Level 2', value: '2' },
    { label: 'Level 3', value: '3' },
  ];
  const onChange1 = ({ target: { value } }: RadioChangeEvent) => {
    setLevel(value);
  };
  useEffect(() => {
    setLevel('1');
  }, []);
  useEffect(() => {
    if ((data as string).length) {
      mermaid.contentLoaded();
    }
  }, [data]);
  useEffect(() => {
    tenantActions.getMermaidDiagram(level, property);
  }, [level]);
  const diagramComponent = (
    <>
      <Radio.Group options={options} onChange={onChange1} value={level} />
      {
        loading || !loaded ? <Spin /> : (
          <div className="mermaid">
            {data}
          </div>
        )
      }
    </>
  );
  const errorComponent = <div className="mermaid-error-message">Diagram not available for the selected model.</div>;
  return (
    <Layout className="main-container">
      <PageTitle title={`${property} Diagram`} back />
      {error === undefined ? diagramComponent : errorComponent}
    </Layout>
  );
};

Erd.displayName = 'ERD Diagram';
export default Erd;
